export default __webpack_public_path__ + "static/media/wl-logo.74c86deb.png";